interface IFormatPriceOptions {
  fractionDigits?: number;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  currencyCode?: string;
  compactDisplay?: 'short' | 'long';
  trailingZeroDisplay?: 'stripIfInteger' | 'auto';
  notation?: 'standard' | 'scientific' | 'engineering' | 'compact';
}

export default function formatPrice(
  val: string | number,
  {
    fractionDigits,
    minimumFractionDigits,
    maximumFractionDigits,
    trailingZeroDisplay,
    currencyCode,
    compactDisplay,
    notation,
  }: IFormatPriceOptions = {
    fractionDigits: 2,
    notation: 'standard',
    compactDisplay: 'long',
  }
): string {
  const formattedNumber = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode || 'USD',
    minimumFractionDigits: minimumFractionDigits || fractionDigits,
    maximumFractionDigits: maximumFractionDigits || fractionDigits,
    compactDisplay,
    notation,
  }).format(Number(val));

  // trailingZeroDisplay is supported natively in the browser already, but not
  // in Node v18 (and TS isn't happy yet either), so we handle the behavior
  // ourselves.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#digit_options
  if (trailingZeroDisplay === 'stripIfInteger') {
    const match = formattedNumber.match(/(\D+)?([\d,]+)\.?(\d+)?(.+)?/);

    if (!match) {
      return formattedNumber;
    }

    const [_, currency, integer, decimals, additionalText] = match;

    // Only ignore decimals if all are set to 0.
    return decimals.split('').every((d) => d === '0')
      ? `${currency || ''}${integer}${additionalText || ''}`
      : formattedNumber;
  }

  return formattedNumber;
}
